import "./Contact.css";
import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import contactContext from "../../../context/contact/contactcontext";

function Contact() {
  const { contactInfo, sendInquiryDetails } = useContext(contactContext);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    dept: "Pregnancy or maternity care",
    message: ""
  });

  const [submittedNote, setSubmittedNote] = useState("");

  const phone = contactInfo.phone ? JSON.parse(contactInfo.phone) : { phone: "080 2334 7276" };
  const email = contactInfo.email ? JSON.parse(contactInfo.email) : { email: "lakshmimaternityhome@gmail.com" };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.phone.trim()) {
      toast.error("Please add your name and a phone number.", { theme: "colored" });
      return;
    }

    if (sendInquiryDetails) {
      sendInquiryDetails({
        name: formData.name,
        email: email.email || "patient@lakshmimaternity.com",
        subject: `Appointment Request — ${formData.dept}`,
        message: `Phone: ${formData.phone}\nDepartment: ${formData.dept}\n\nNotes:\n${formData.message}`
      });
    }

    const bodyText = `Name: ${formData.name}\nPhone: ${formData.phone}\nRegarding: ${formData.dept}\n\n${formData.message}`;
    window.location.href = `mailto:${email.email || "lakshmimaternityhome@gmail.com"}?subject=${encodeURIComponent("Appointment request — " + formData.name)}&body=${encodeURIComponent(bodyText)}`;

    setSubmittedNote("Thank you! Your request is being processed. If urgent, please call " + (phone.phone || "080 2334 7276") + ".");
    toast.success("Appointment request sent successfully!", { theme: "colored" });
  };

  return (
    <section className="band tint" id="contact">
      <div className="wrap">
        <div className="contact-grid">
          <div>
            <p className="eyebrow">Visit us</p>
            <h2 className="h-sec">Margosa Road, Malleswaram.</h2>
            <p className="body-copy" style={{ marginTop: "22px" }}>
              We are opposite the Malleswaram Exchange, in the heart of north Bangalore. Call ahead and we will tell you the quickest way in.
            </p>
            <ul className="cinfo">
              <li>
                <span className="lbl">Address</span>
                <span>95 &amp; 96, Margosa Road, Opposite Malleswaram Exchange, Malleswaram, Bangalore</span>
              </li>
              <li>
                <span className="lbl">Phone</span>
                <span>
                  <a href={`tel:${phone.phone || "08023347276"}`}>{phone.phone || "080 2334 7276"}</a>
                </span>
              </li>
              <li>
                <span className="lbl">Email</span>
                <span>
                  <a href={`mailto:${email.email || "lakshmimaternityhome@gmail.com"}`}>
                    {email.email || "lakshmimaternityhome@gmail.com"}
                  </a>
                </span>
              </li>
              <li>
                <span className="lbl">Labour &amp; delivery</span>
                <span>Available 24 hours, every day of the year</span>
              </li>
              <li>
                <span className="lbl">Directions</span>
                <span>
                  <a
                    href="https://maps.google.com/?q=Lakshmi+Maternity+%26+Surgical+Centre,+Margosa+Road,+Malleswaram,+Bangalore"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open in Google Maps
                  </a>
                </span>
              </li>
            </ul>
          </div>

          <form id="appointment" onSubmit={handleSubmit} noValidate>
            <h3>Request an appointment</h3>
            <p style={{ marginTop: "10px", color: "var(--muted)", fontSize: "15px" }}>
              Tell us a little about what you need and we will call you back to confirm a time.
            </p>
            <div className="field">
              <label htmlFor="f-name">Full name</label>
              <input
                id="f-name"
                name="name"
                type="text"
                autoComplete="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
              />
            </div>
            <div className="field">
              <label htmlFor="f-phone">Phone number</label>
              <input
                id="f-phone"
                name="phone"
                type="tel"
                autoComplete="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Your Phone"
                required
              />
            </div>
            <div className="field">
              <label htmlFor="f-dept">What is it about?</label>
              <select id="f-dept" name="dept" value={formData.dept} onChange={handleChange}>
                <option value="Pregnancy or maternity care">Pregnancy or maternity care</option>
                <option value="Gynaecology consultation">Gynaecology consultation</option>
                <option value="Paediatrics or newborn care">Paediatrics or newborn care</option>
                <option value="PCOS, periods or hormonal health">PCOS, periods or hormonal health</option>
                <option value="Infertility treatment">Infertility treatment</option>
                <option value="General medical consultation">General medical consultation</option>
              </select>
            </div>
            <div className="field">
              <label htmlFor="f-msg">Anything we should know (Optional)</label>
              <textarea
                id="f-msg"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Due date, symptoms, or a preferred time to be called."
              ></textarea>
            </div>
            <button className="btn-solid" type="submit" style={{ width: "100%", marginTop: "22px" }}>
              Request appointment
            </button>
            <p className="form-note" id="formNote">
              {submittedNote || (
                <>
                  This form submits your booking request. For anything urgent, please call{" "}
                  <a href={`tel:${phone.phone || "08023347276"}`} style={{ color: "var(--green-deep)", fontWeight: 600 }}>
                    {phone.phone || "080 2334 7276"}
                  </a>
                  .
                </>
              )}
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;